import { render, staticRenderFns } from "./PlaceGridBlock.vue?vue&type=template&id=096ef73e&scoped=true&"
import script from "./PlaceGridBlock.vue?vue&type=script&lang=js&"
export * from "./PlaceGridBlock.vue?vue&type=script&lang=js&"
import style0 from "./PlaceGridBlock.vue?vue&type=style&index=0&id=096ef73e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096ef73e",
  null
  
)

export default component.exports